export const upsellingHc = {
  servicios: {
    accommodation: `Alloggio`,
    all: `Tutti`,
    state: `Stato`,
    search: `Cerca`,
    searchPlaceholder: `Ospite o codice di prenotazione…`,
    from: `Dal`,
    to: `Al`,
    today: `Oggi`,
    noDate: `Senza data`,
    clear: `Cancella`,
    thService: `Servizio`,
    thGuest: `Ospite`,
    thBooking: `Prenotazione`,
    thRequested: `Richiesto il`,
    statusConsult: `Su richiesta`,
    statusRejected: `Rifiutato`,
    statusPaid: `Pagato`,
    statusPartial: `Pagamento parziale`,
    statusApproved: `Approvato`,
    statusPending: `In attesa`,
    serviceFallback: `Servizio`,
    openBookingTitle: `Apri la prenotazione`,
    approve: `Approva`,
    reject: `Rifiuta`,
    viewBooking: `Vedi prenotazione`,
    noRecords: `Nessun record`,
    noRecordsFiltered: `Nessun record trovato con i filtri applicati.`,
    noRequestsYet: `Non appena un ospite richiederà un servizio, comparirà qui.`,
    chipBreakfast: `Colazione`,
    chipTour: `Tour`,
    chipTransport: `Trasporto`,
    chipMore: `E tutto ciò che offri`,
    approveTitle: `Approva richiesta`,
    amountLabel: `Importo da addebitare`,
    amountFree: `0 = senza addebito`,
    amountHint: `Con un gateway di pagamento collegato, all'ospite viene inviato un <strong>link di pagamento</strong> (WhatsApp + e-mail). In caso contrario, gli viene comunicato che <strong>pagherà all'arrivo</strong>.`,
    cancel: `Annulla`,
    processing: `Elaborazione in corso…`,
    approveAndNotify: `Approva e avvisa`,
    amountInvalid: `Indica un importo valido (0 = senza addebito).`,
    approvedPaymentLink: `Approvata. Il link di pagamento è stato inviato all'ospite (WhatsApp + e-mail).`,
    approvedOnArrival: `Approvata. L'ospite pagherà all'arrivo (nessun gateway collegato).`,
    approvedNotified: `Approvata. L'ospite è stato avvisato.`,
    approveFailed: `Impossibile approvare la richiesta.`,
    rejectTitle: `Rifiuta richiesta`,
    rejectMessage: `Rifiutandola, l'ospite NON verrà addebitato per questo servizio e verrà avvisato. Rifiutare la richiesta?`,
    rejected: `Richiesta rifiutata. L'ospite è stato avvisato.`,
    rejectFailed: `Impossibile rifiutare la richiesta.`,
  },
  form: {
    basicTitle: `Informazioni di base`,
    basicDesc: `Il nome e la descrizione che vedrà l'ospite.`,
    autoTranslate: `Scrivilo nella <strong>tua lingua</strong>. Al salvataggio viene tradotto <strong>automaticamente</strong> in tutte le lingue (spagnolo, inglese, portoghese, francese, tedesco, italiano, cinese e arabo); l'ospite vedrà la sua.`,
    selectPlaceholder: `Seleziona…`,
    catNightlife: `Vita notturna`,
    subtitleLabel: `Sottotitolo`,
    optional: `facoltativo`,
    subtitlePlaceholder: `Un gancio breve, es.: “Vivi l'esperienza”`,
    price: `Prezzo`,
    priceDesc: `Come viene addebitato questo servizio all'ospite.`,
    segWithPrice: `Con prezzo`,
    segWithPriceDesc: `Addebitato automaticamente`,
    segOnRequest: `Su richiesta`,
    segOnRequestDesc: `L'ospite chiede, tu fai il preventivo`,
    currencyLabel: `Valuta`,
    currencyHint: `quella dell'annuncio`,
    chargeBy: `Addebita per`,
    unitPlaceholder: `Scegli la modalità…`,
    unitPerUnit: `Per unità (prezzo fisso)`,
    unitPerPerson: `A persona (× ospiti)`,
    unitPerNight: `A notte (× notti)`,
    unitPerGroup: `Per gruppo / soggiorno`,
    unitPerHour: `All'ora`,
    unitHintPerson: `Verrà moltiplicato per il numero di ospiti della prenotazione.`,
    unitHintNight: `Verrà moltiplicato per il numero di notti della prenotazione.`,
    unitHintUnit: `Prezzo fisso per ogni unità che l'ospite acquista.`,
    unitHintGroup: `Prezzo unico per la prenotazione, indipendentemente da persone o notti.`,
    unitHintHour: `Prezzo per ora prenotata.`,
    unitLabelPerson: `/ a persona`,
    unitLabelNight: `/ a notte`,
    unitLabelGroup: `/ a soggiorno`,
    unitLabelHour: `/ all'ora`,
    stockControl: `Controlla lo stock`,
    inventory: `inventario`,
    stockDesc: `Per ciò che si esaurisce (es. un letto o una culla extra): limita le unità. Vengono scalate automaticamente a ogni prenotazione e in tempo reale.`,
    unitsAvailable: `Unità disponibili`,
    removeUnitAria: `Rimuovi un'unità`,
    addUnitAria: `Aggiungi un'unità`,
    stockNoteSoldOut: `A <strong>0</strong> unità il servizio appare <strong>Esaurito</strong> e non può essere aggiunto.`,
    stockNoteAuto: `Al raggiungimento di 0 verrà mostrato <strong>Esaurito</strong> automaticamente.`,
    stockConsumePerson: `Ogni prenotazione scala 1 unità per ospite.`,
    stockConsumeNight: `Ogni prenotazione scala 1 unità per notte.`,
    stockModeTitle: `Come funziona lo stock`,
    stockModeAvail: `Per disponibilità`,
    stockModeAvailDesc: `Viene occupato solo durante il soggiorno e liberato al check-out (culla, letto extra).`,
    stockModeProduct: `Per prodotto`,
    stockModeProductDesc: `Viene scalato a ogni prenotazione e non torna. Lo riassortisci manualmente.`,
    stockUnlimited: `Stock illimitato — nessun limite di unità.`,
    photosTitle: `Foto`,
    photoMain: `Principale`,
    makeMainTitle: `Imposta come principale`,
    removeTitle: `Rimuovi`,
    addPhoto: `Aggiungi foto`,
    addPhotos: `Aggiungi foto`,
    reorderHint: `Trascina per riordinare · la prima è quella mostrata sulla scheda.`,
    whereTitle: `Dove viene offerto?`,
    whereDesc: `Annunci in cui sarà disponibile. Nessuna selezione = tutti.`,
    selected: `{count} selezionati`,
    all: `Tutti`,
    none: `Nessuno`,
    searchListingPlaceholder: `Cerca annuncio…`,
    noResults: `Nessun risultato`,
    diffCurrencyTitle: `Questo annuncio usa {currency}. Un servizio resta in una sola valuta.`,
    unit: `unità`,
    units: `unità`,
    loadingListings: `Caricamento annunci…`,
    previewLabel: `Anteprima · ecco come la vedrà l'ospite`,
    previewPhoto: `La tua foto principale`,
    previewTitleFallback: `Nome del servizio`,
    previewDescFallback: `Qui comparirà la descrizione che scrivi, così l'ospite sa cosa è incluso.`,
    free: `Gratis`,
    soldOut: `Esaurito`,
    add: `Aggiungi`,
    remaining: `Resta {count} unità | Restano {count} unità`,
    scopeManaged: "Si offre in <strong>tutti i tuoi annunci</strong>. Scegli quali dall'elenco Servizi ed esperienze.",
    scopeAll: `Disponibile in <strong>tutti i tuoi alloggi</strong>`,
    scopeSome: `Disponibile in <strong>{count}</strong> annuncio | Disponibile in <strong>{count}</strong> annunci`,
    errNameRequired: `Il nome è obbligatorio`,
    errCategoryRequired: `La categoria è obbligatoria`,
    errDescRequired: `La descrizione è obbligatoria`,
    errPriceRequired: `Inserisci un prezzo (metti 0 se è gratis).`,
    errPriceNegative: `Il prezzo non può essere negativo.`,
    errUnitRequired: `Scegli come viene addebitato (Addebita per)`,
    errStockRequired: `Indica quante unità ci sono in stock (metti 0 se esaurito).`,
    errProcessing: `Errore durante l'elaborazione della richiesta.`,
  },
  createServicio: {
    subtitle: `Compila le informazioni e guarda l'anteprima in tempo reale.`,
    photosDesc: `Aggiungi quante vuoi · la 1ª è la principale · JPG, PNG o WebP.`,
    imageRequired: `Carica almeno un'immagine.`,
  },
  updateServicio: {
    title: `Modifica esperienza o servizio`,
    subtitle: `Aggiorna le informazioni e guarda l'anteprima in tempo reale.`,
    loadingAria: `Caricamento servizio`,
    photosDesc: `Aggiungi o rimuovi quante vuoi · la 1ª è la principale · JPG, PNG o WebP.`,
    save: `Salva modifiche`,
    imageRequired: `Deve rimanere almeno un'immagine.`,
    loadFailed: `Impossibile caricare il servizio.`,
  },
  configUpselling: {
    title: `Configurazione Vendite Incrociate`,
    phoneIntro: `Inserisci il numero di telefono che vuoi usare per ricevere le notifiche delle richieste di servizio tramite WhatsApp`,
    saveWhatsapp: `Salva WhatsApp`,
    editWhatsapp: `Modifica WhatsApp`,
    mustEnterWhatsapp: `Devi inserire il WhatsApp`,
    swalTitle: `WhatsApp delle vendite incrociate`,
    swalText: `Riceverai tutte le notifiche dei servizi richiesti dai clienti`,
    cancel: `Annulla`,
    addedSuccess: `WhatsApp aggiunto con successo`,
  },
};
